var max = function(values) {
	return values.reduce(function(max, i) {
		return Math.max(max, i);
	}, Number.MIN_VALUE);
};

var min = function(values) {
	return values.reduce(function(min, i) {
		return Math.min(min, i);
	}, Number.MAX_VALUE);
};

var average = function(values) {
	return sum(values) / values.length;
};

var stddev = function(values) {
	var u = average(values);
	var squareDiffs = values.map(function(x) { return Math.pow(x - u, 2); });
	return Math.sqrt(
		sum(squareDiffs) / values.length
	);
};

var sum = function(values) {
	return values.reduce(function(total, i) { 
		return total + Number(i);
	}, 0);
};

var copy = function(values) {
	return values.slice(0);
};

var sort = function(values) {
	var rv = copy(values);
	return rv.sort(function(a, b) { return a - b; });
};

var histogram = function(values, divisor) {
	var buckets = [];
	var divisor = divisor || 1;

	values.forEach(function(v) {
		if (!buckets[v]) buckets[v] = 0;
		buckets[v] += 1;
	});

	buckets = buckets.map(function(v) {
		return v / divisor;
	});

	return buckets;
};

var shuffle = function(values) {
	var rv = copy(values);
	var temp = null;
	var targetIndex = 0;
	var size = rv.length;
	for (var sourceIndex = size - 1; sourceIndex > 0; sourceIndex--) {
		targetIndex = Math.floor(Math.random() * (sourceIndex + 1));
		temp = rv[sourceIndex];
		rv[sourceIndex] = rv[targetIndex];
		rv[targetIndex] = temp;
	}
	return rv;
};

var shuffleTest = function(digits, runsPerPermutation) {
	digits = Math.min(8, Math.max(1, Number(digits || 3)));
	var alphabet = "abcdefgh".substr(0, digits).split('');
	var results = {};
	var permutations = this.factorial(digits);
	var runs = permutations * (runsPerPermutation || 100);
	
	for (var i = 0; i < runs; i++) {
		var s = shuffle(alphabet).join('');
		if (!results[s]) { results[s] = ''; }
		results[s] = results[s] + '#';
	}
	
	var histo = [];
	for (var k in results) {
		histo.push(k + ': ' + results[k]);
	}
	console.log(histo.join("\n"));
};

var median = function(values) {
	var sorted = sort(values);
	var middle = (values.length - 1)/2;
	var lower = sorted[Math.floor(middle)];
	var upper = sorted[Math.ceil(middle)];
	return (lower + upper)/2;
};

var identity = function(x) {
	return x;
};

var Study = function(population, base, criteria, trials, precision) {
	var _t = this;
	var samplesPerTrial = Math.pow(10, precision);
	var virtualPrecision = Math.floor(precision + 1);
	this.values = [];
	this.trials = [];
	this.index = {};

	this.reset = function() {
		this.values = [];
		this.trials = [];
		this.index = [];
	};

	this.run = function() {
		this.reset();

		for (var i = 0; i < trials; i++) {
			var t = new Trial(population, base, criteria, samplesPerTrial);
			this.trials.push(t);
			
			var bucket = (t.rate * 100).toPrecision(virtualPrecision);
			this.index[bucket] = (this.index[bucket] || 0) + 1;

			if (typeof(this.onProgress) == 'function') {
				this.onProgress(i/trials);
			} 
		}

		for (var y = 0; y <= samplesPerTrial; y++) {
			var bucket = Number(100 * (y/samplesPerTrial)).toPrecision(virtualPrecision);
			this.values.push({
				x: bucket,
				y: this.index[bucket] || 0
			});
		}

		if (typeof(this.onComplete) == 'function') {
			this.onComplete();
		}
	};

	this.getDrawRequirements = function() {
		var odds = {};

		this.trials.forEach(function(trial) {
			for (var criteria in trial.draw_matches) {
				if (!odds[criteria]) odds[criteria] = [];
				trial.draw_matches[criteria].forEach(function(stats, hits) {
					if (!odds[criteria][hits]) odds[criteria][hits] = [];
					odds[criteria][hits].push(stats.probability);
				});
			}
		});

		for (var criteria in odds) {
			odds[criteria] = odds[criteria].map(function(probabilities) {
				return median(probabilities);
			});
		}

		return odds;
	};

	this.getWithConfidence = function(confidence) {
		var percentile = 1 - confidence;
		var total = 0;
		var rate = {x:0, y:0};

		for (var i = 0; i < this.values.length && total/trials < percentile; i++) {
			rate = this.values[i];
			total += rate.y;
		}

		var missedCards = 0;
		var missedDeals = 0;
		for (var i = 0; i < this.trials.length; i++) {
			var t = this.trials[i];
			missedDeals += t.misses;
			missedCards += t.missedCards;
		}

		return {
			rate: rate.x,
			missRate: (missedCards / missedDeals).toFixed(1),
			drawRequirements: this.getDrawRequirements()
		};
	};

	this.getHistogram = function(percentileMarker) {
		var total = 0;
		var marked = false;
		percentileMarker = percentileMarker || 0.5;
		var histo = this.values.map(function(b, i) {
			var marker = '';
			total += b.y;
			if (!marked && total/trials > percentileMarker) {
				marker = '----- ' + percentileMarker + " -----\n";
				marked = true;
			}
			var rv = [
				marker,
				(b.x + ',' + b.y + "        ").substr(0, precision + 4) + ': '
			];
			for (var i = 0; i < b.y; i++) rv.push('#');
			return rv.join('');
		});
		return histo.join("\n");
	};

};

var Trial = function(population, base, criteria, samples) {
	var _t = this;

	this.population = population;
	this.base = base;
	this.criteria = criteria;
	this.samples = samples;
	this.successes = 0;
	this.misses = 0;
	this.missedCards = 0;
	this.tests = [];

	this.draw_matches = {};
	this.criteria.forEach(function(criterion) {
		_t.draw_matches[criterion.name] = [];
		for (var i = 0; i <= (criterion.drawSize + base.length); i++) {
			_t.draw_matches[criterion.name][i] = {
				successes: 0, failures: 0
			};
		}
	});

	for (var i = 0; i < samples; i++) {
		var t = new Test(shuffle(population), base, criteria);
		this.tests.push(t);
		if (t.passes) {
			this.successes += 1;
			var addTo = 'successes';
		} else {
			this.misses += 1;
			this.missedCards += t.misses;
			var addTo = 'failures';
		}

		for (var criterion in t.draw_matches) {
			this.draw_matches[criterion][t.draw_matches[criterion]][addTo] += 1;
		}
	}

	for (var criteria in this.draw_matches) {
		this.draw_matches[criteria].forEach(function(count) {
			count.probability = count.successes / (
				count.successes+count.failures
			);
			if (Number.isNaN(count.probability)) count.probability = 0;
		});
	}

	this.rate = this.successes / this.samples;
	this.missAverage = this.misses / this.samples;
};

var Test = function(population, base, criteria) {
	this.misses = 0;
	this.population = population;
	this.base = base;
	this.passes = true;
	this.draw_matches = {};

	for (const criterion of criteria) {
		// for both computations below, the `base` set is the set of cards
		// that are assumed to be available at any time. E.g., the commander.

		// compute how many misses we have within the requested `sample`, where
		// `sample` = `needsBy + drawSize`, essentially.
		let slice = this.population.slice(0, criterion.sample);
		let matches = 0;

		for (const card of [...base, ...slice]) {
			if (card[criterion.name]) matches++;
		}
		// for (var item_i = 0; item_i < slice.length; item_i++) {
		// 	if (slice[item_i][criterion_name]) matches++;
		// }
		this.misses += Math.max(0, criterion.needed - matches);

		// determine how many matches there will be in the draw.
		// criterion.drawSize is just drawSize smuggled into the criterion object.
		// (see components/analysis/analysis.js)
		let draw_slice = this.population.slice(0, criterion.drawSize);
		let draw_matches = 0;
		for (const card of [...base, ...draw_slice]) {
			if (card[criterion.name]) draw_matches++;
		}
		// for (var item_i = 0; item_i < draw_slice.length; item_i++) {
		// 	if (draw_slice[item_i][criterion_name]) draw_matches++;
		// }
		this.draw_matches[criterion.name] = draw_matches;
	};

	if (this.misses > 0) {
		this.passes = false;
	}
};

module.exports = {

	sum: sum,
	average: average,
	stddev: stddev,
	min: min,
	max: max,
	sort: sort,
	shuffle: shuffle,
	shuffleTest: shuffleTest,
	median: median,
	identity: identity,
	Test: Test,

	drawSuccess: function drawSuccess(
		minMatches, maxMatches, drawCount, matchesInPopulation, populationSize
	) {
		var probability = 0;
		for (var matches = minMatches; matches <= maxMatches; matches++) {
			probability = probability + this.hypgeodist(
				matches, drawCount, matchesInPopulation, populationSize
			);
		}
		return Math.max(Math.min(probability, 1), 0);
	},

	hypgeodist: function(matches, draws, matchesInPopulation, populationSize) {
		if (matches > draws || draws > populationSize) return 0;
		var totalHands = this.choose(populationSize, draws);
		var waysToChooseSuccesses = this.choose(matchesInPopulation, matches);
		var waysToChooseFillers = this.choose(
			populationSize - matchesInPopulation, draws - matches
		);
		var successfulHands = waysToChooseSuccesses * waysToChooseFillers;
		var probability = successfulHands / totalHands;
		return probability;		
	},

	hypergeometricdistribution: function(k, n, K, N) {
		return this.hypgeodist(k, n, K, N);
	},

	drawRange: function(confidence, drawCount, matchesInPopulation, populationSize) {
		var lowerIsFound = false;
		var lower = 0;
		var upper = Math.min(drawCount, matchesInPopulation);
		var probability = 0;
		var matches = 0;

		var lowerCutoff = (1 - confidence) / 2;
		var upperCutoff = 1 - lowerCutoff;

		while (probability < upperCutoff && matches < Math.min(drawCount, matchesInPopulation)) {
			probability += this.hypgeodist(matches, drawCount, matchesInPopulation, populationSize);
			if (!lowerIsFound && probability > lowerCutoff) {
				lower = matches;
				lowerIsFound = true;
			}
			upper = matches;
			matches++;
		}

		return { lower: lower, upper: upper };
	},

	interval: function(data, select) {
		var lower = null;
		var upper = null;

		var limit = select;
		if (typeof(select) != 'function') {
			select = function(y) {
				return y >= limit;
			}
		}

		for (var x = 0; x < data.length; x++) {
			var y = data[x];
			if (select(y)) {
				if (lower === null) {
					lower = x;
				}
				upper = x;
			}
		}
		
		return { lower: lower, upper: upper };
	},

	choose: function(population, draws) {
		if (population < draws) return 0;
		if (population == draws) return 1;
		var rv = this.factorialDivide(
			population, Math.max(draws, population - draws)
		);
		rv = rv / this.factorial(Math.min(draws, population - draws));
		return rv;
	},

	product: function(i, n, f) {
		var rv = 1;
		f = typeof(f) == 'function' ? f : identity;
		while (i <= n) {
			rv = rv * f(i);
			i = i + 1;
		}
		return rv;
	},

	factorial: function(n, dividedByFactorialOf) {
		return this.product(1, n);
	},

	// returns: n!/d!
	factorialDivide: function(n, d) {
		if (d == 0) { return Infinity; }
		if (n == 0) { return 0; }

		var _n = 1;
		var _d = 1;

		if (n > d) {
			_n = this.product(d + 1, n);
		} else {
			_d = this.product(n + 1, d);
		}

		return _n/_d;
	},

	Study: Study,
	Trial: Trial,

};
